module.exports = __webpack_public_path__ + "img/icon-menu-tnc.87409bfa.svg";